
import Paging from '@/components/Table/Paging'
import EventBus from '@/utils/eventBus'
export default {
  components: {
    Paging
  },
  props: {
    screen:{
      type: Object,
      default: () => {}
    },
  },
  data() {
    return {
      url: {
        list: SZH.assets.api + '/Custom/GetPageRedisMessage',
        SetRead: SZH.assets.api + '/Custom/SetRead',//设置已读
        DeleteMessage: SZH.assets.api + '/Custom/DeleteMessage',//删除
      },
      loading:true,
      queryParams: {
        status:0
      },
      selection:[]
    }
  },
  methods: {
    goBack(){
      this.$router.push({
        path: '/My/UserInfo'
      })
    },
    handleSelectionChange(val){
      this.selection = val;
    },
    onSearch(row){
      let self = this;
      self.$http.post(self.url.SetRead,{
        keys:row.Key
      })
        .then(result => {
          if (result.state == true) {
            self.$refs['paging'].reload();
            self.$nextTick(()=>{
              if(row.ObjectType == 1 || row.ObjectType == 2){
                self.$alert(row.ObjectMessage, '工单消息', {
                  confirmButtonText: '去回复',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/Notice',
                      query:{
                        id:row.ObjectId
                      }
                    })
                  }
                });
              }else if(row.ObjectType == 11){
                self.$alert(row.ObjectMessage, '法律文书消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/LawList',
                      query:{
                        id:row.ObjectId
                      }
                    })
                  }
                });
              }else if(row.ObjectType == 12){
                self.$alert(row.ObjectMessage, '留言消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/MessageBoard',
                      query:{
                        id:row.ObjectId,
                        accountId:row.ToUserId
                      }
                    })
                  }
                });
              }else if(row.ObjectType >=3 && row.ObjectType <=8){
                self.$alert(row.ObjectMessage, '案件消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/CaseManagement'
                    })
                  }
                });
              }else if(row.ObjectType ==9 || row.ObjectType ==10){
                self.$alert(row.ObjectMessage, '合同消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/ContractManagement'
                    })
                  }
                });
              }else if(row.ObjectType ==20 || row.ObjectType ==30 || row.ObjectType ==40){
                self.$alert(row.ObjectMessage, '会员消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/MemberCenter'
                    })
                  }
                });
              }else if(row.ObjectType ==50){
                self.$alert(row.ObjectMessage, '提现消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/CashRequest'
                    })
                  }
                });
              }else if(row.ObjectType ==60){
                self.$alert(row.ObjectMessage, '发票消息', {
                  confirmButtonText:'去查看',
                  center:true,
                  callback: action => {
                    self.$router.push({
                      path: '/My/Invoice'
                    })
                  }
                });
              }
            });

          } else {
            self.$message.error(result.message);
          }

        }, () => {
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });


    },
    onRead(){
      let self = this;
      if(self.selection && self.selection.length == 0){
        self.$message.error('请选择消息!');
        return
      }
      const idsString = self.selection.map(item => item.Key).join(',');
      self.loading = true;
      self.$http.post(self.url.SetRead,{
        keys:idsString
      })
        .then(result => {
          if (result.state == true) {
            self.loading = false;
            self.$refs['paging'].reload();
          } else {
            self.loading = false;
            self.$message.error(result.message);
          }

        }, () => {
          self.loading = false;
          // 请求失败
          self.$message.error('登录失败，请检查您的网络是否可用。');
        });
    },
    onDelete(){
      let self = this;
      if(self.selection && self.selection.length == 0){
        self.$message.error('请选择消息!');
        return
      }
      self.$confirm('确定批量删除消息吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        center:true,
        type: 'warning'
      }).then(() => {
        const idsString = self.selection.map(item => item.Key).join(',');
        self.loading = true;
        self.$http.post(self.url.DeleteMessage,{
          keys:idsString
        })
          .then(result => {
            if (result.state == true) {
              self.loading = false;
              self.$message({
                type: 'success',
                message: '删除成功!'
              });
              self.$refs['paging'].reload();
            } else {
              self.loading = false;
              self.$message.error(result.message);
            }

          }, () => {
            self.loading = false;
            // 请求失败
            self.$message.error('登录失败，请检查您的网络是否可用。');
          });

      }).catch(() => {
        self.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    changeState(){
      this.loading = true;
      this.$refs['paging'].reload();
    },
    onLoaded() {
      this.loading = false;
      EventBus.$emit('header-update', {
        title: '改变le'+new Date().getTime(),
      });
    }
  },
  computed: {

  },
  created() {
  },
  mounted() {


  },
  watch: {
  }
}



// WEBPACK FOOTER //
// ./src/views/Message/Message.js